import React, {useState, useEffect} from 'react';
import './Compain.css';
import { observer } from 'mobx-react';
import Sidebar from '../../components/sidebar/index.js';
import CompainAi from '../../components/compain/index.js';
import Beta from '../../components/Beta/index.js';
import UserPool from '../../components/autorize/UserPool.js';
import Mini from '../../components/mini/index.js'
import { useParams } from 'react-router-dom';


import {Helmet} from "react-helmet";
const Strategy = observer(() => {
    const [holdBlock, setholdBlock] = useState(true);
    const [datasegment, setDatasegment] = useState(1);
    const [user, setUser]=useState("");
    const changemenu = () =>{
        setholdBlock(false)
    }
    window.onbeforeunload = () => {
        setholdBlock(true)
    }
    const { id_goal, id_comp } = useParams();

    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const token = localStorage.getItem("token");
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const cognitoUser = UserPool.getCurrentUser();
            setUser(cognitoUser.username)
        } 
    }, []);
    return (
        <>
            {
                langmenu=="de"?
                <Helmet>
                    <title>Beinf.ai - your data-driven AI marketing talent that drives loyalty</title>
                    <meta name="description" content="Beinf.ai — eine No-Code-Lösung für maschinelles Lernen. Entscheidungsfindung auf Basis einer tiefgehenden Analyse historischer Ereignisse und Prognosen." />
                </Helmet>
                :
                <Helmet>
                    <title>Beinf.ai - your data-driven AI marketing talent that drives loyalty</title>
                    <meta name="description" content="Beinf.ai — a no-code machine learning solution. Decision-making based on in-depth analysis of historical events and forecasting." />
                </Helmet>
            }
            <Sidebar/>
            {
                user=="admin"||
                user=="dev_1"||
                user=="gewgur"||
                user=="test_team_2"||
                user=="test_team_3"||
                user=="test_team_4"||
                user=="test"||
                user=="m.bahmat"||
                user=="k.zaporozhchenko"||
                user=="m.tsvyd"||
                user=="DemoBG"||
                user=="d.tarasenko@beinf.ai"||
                user=="tempuser"||
                user=="case_1"||
                user=="case_2"||
                user=="case_4"||
                user=="v.cherdak@taluno.ai"||
                user=="ikm@taluno.ai"||
                user=="case_3"?
                
                <>
                <div className="strategy">
                    <div className='body_strategy'>
                        <CompainAi goal={id_goal} comp={id_comp}/>
                    </div>
                </div>
                <Mini/>
                </>
                :
                <div className="main-page">
                    <Beta/>
                </div>
            }
       
        </>
    );
})

export default Strategy;

